import { ViewMode } from 'core/structs/ViewMode'
import { TextDirection } from 'core/theme/ThemeContext'

// define constant here
export const STORAGE_TOKEN_KEY = 'TOKEN'
export const DEVICE_UUID = 'DEVICE_UUID'
export const APP_ID = 'APP_ID'
export const STORAGE_USER = 'USER'
export const PAGE_NUMBER_PREVIOUS = 'PAGE_NUMBER_PREVIOUS'
export const MAXIMUM_SCALE = 2.5
export const DEFAULT_SCALE = 1
export const VISITED = 'VISITED'
export const DEFALUT_PER_PAGE = 20
export const DEFAULT_PAGE = 1
export const DATE_FORMAT = 'YYYY年MM月DD日'
export const DATE_TIME_DISPLAY = 'YYYY年MM月DD日 HH:mm'
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm'
export const PDF_DOCUMENT = 'PDF_DOCUMENT'
export const MAGAZINE_VIEW_LOG = 'MAGAZINE_VIEW_LOG'
export const MAX_FILE_SIZE = 5242880
export const PERIOD_MONTH_FUTURE_MAGAZINE = 12

export const ViewModeMapData: Record<number, ViewMode> = {
  1: ViewMode.DualPage,
  2: ViewMode.SinglePage
}

export const DirectionModeMapData: Record<number, TextDirection> = {
  1: TextDirection.RightToLeft,
  2: TextDirection.LeftToRight
}
